import isEqual from "lodash/isEqual";
import {useEffect, useState} from "react";
import {useMutation} from "react-query";
import {httpGET, httpPUT} from "../../utils/ajaxHelper";
import AGButton from "../Button";

import {Formik, FormikProps} from "formik";
import {useContext, useRef} from "react";
import {
  Address,
  AgnetRegion,
  ComMainService,
  CommerceFirmDatumRes,
  CompracticeLevel,
  FirmAddress,
  Individual,
  SecondaryInterestType,
} from "../../models";
import AGSelect from "../AgSelect";

import {UserContext} from "../../Provider";

import moment from "moment";
import {useParams, useSearchParams} from "react-router-dom";
import {UpdateCommerceSecondmentSchema} from "../../Schema/CommerceCompassSchema";
import {ADMIN_ORGANIZATION, MODAL_CONSTANT} from "../../utils/constant";
import AGCheckbox from "../Checkbox";
import AGModal from "../Modal";
import {CommerceCompassStyled, CustomBackground} from "../ModalAddService/modalAddService.styled";
import {useNotification} from "../Notification";
import {RolesHandle} from "../RolesHandle";
import {default as AGtextarea} from "../Textarea";
import Tooltip from "../Tooltip";
import { title } from "process";
import AGInput from "../Input";

export interface UpdateSecondmentModalProps {
  visible: boolean;
  toggleModal: () => void;
  toggleError: () => void;
  offeringId: string;
  publishComplete: () => void;
  onDeleteService?: (e: boolean) => void;
  initSearchParams?: any;
  organizationId?: number;
  onEditSuccess?: (rs: any) => void;
}
const UpdateSecondmentModal = ({
  visible,
  toggleModal,
  toggleError,
  offeringId,
  publishComplete: publicComplete,
  onDeleteService,
  initSearchParams,
  organizationId,
  onEditSuccess
}: UpdateSecondmentModalProps) => {
  const handleClose = () => {
    toggleModal();
  };
  const handleErrorClose = () => {
    toggleError();
  };
  const {showNotification} = useNotification();
  const [submitCount, setSubmitCount] = useState<number>(0);
  const [firmData, setFirmData] = useState<CommerceFirmDatumRes | undefined>();
  const [agnetRegion, setAgnetRegion] = useState<AgnetRegion[]>();
  const [addAgnetRegion, setAddAgnetRegion] = useState<AgnetRegion[]>();
  const [firmAddresses, setFirmAddresses] = useState<Address[]>();
  const [comMainService, setComMainService] = useState<ComMainService[]>();
  const [individual, setIndividual] = useState<Individual[]>();
  const formRef = useRef<FormikProps<any>>(null);
  const componentRef = useRef<HTMLDivElement>(null);
  const user = useContext(UserContext);
  const [searchParams, setSearchParams] = useSearchParams();
  const [isDataChanged, setIsDataChanged] = useState<boolean>(false);
  const {id} = useParams();
  const [compracticeLevel, setCompracticeLevel] = useState<CompracticeLevel[]>();
  const [submitType, setSubmitType] = useState<"Draff" | "Publish" | undefined>(undefined);

  const [interestType, setInterestType] = useState<SecondaryInterestType[]>();

  const {mutate: getAgnetRegion} = useMutation(
    (firmId: number | undefined) =>
      httpGET({
        url: "/agnetregion/secondment",
        params: {firmId: firmId, type: "SECONDMENT"},
      }),
    {
      onSuccess: (rs) => {
        setAgnetRegion(rs as AgnetRegion[]);
      },
    },
  );
  const {mutate: getAddEditAgnetRegion} = useMutation(
    (firmId: number | undefined) =>
      httpGET({
        url: "/agnetregion/add-edit",
        params: {firmId: firmId},
      }),
    {
      onSuccess: (rs) => {
        setAddAgnetRegion(rs as AgnetRegion[]);
      },
    },
  );

  const {mutate: initData} = useMutation(
    (id: string) =>
      httpGET({
        url: `/CommerceFirmData/secondment/${id}`,
      }),
    {
      onSuccess: (rs) => {
        setFirmData(rs as CommerceFirmDatumRes);
      },
    },
  );

  const {mutate: getIndividuals} = useMutation(
    (id: any) =>
      httpGET({
        url: "/Individuals",
        params: {id},
      }),
    {
      onSuccess: (rs) => {
        setIndividual(rs as Individual[]);
      },
    },
  );

  const {mutate: getCompracticeLevel} = useMutation(
    () =>
      httpGET({
        url: "/compracticeLevel",
      }),
    {
      onSuccess: (rs) => {
        setCompracticeLevel(rs as CompracticeLevel[]);
      },
    },
  );

  const {mutate: getInterestTypes} = useMutation(
    async () => {
      const response = await httpGET({url: "/CommerceFirmData/interestTypes"});
      return response;
    },
    {
      onSuccess: (rs) => {
        if (!Array.isArray(rs)) {
          console.error("API response is not an array:", rs);
          return;
        }

        const formattedInterestTypes = rs.map((e) => ({
          secondmentInterestTypeId: e.secondmentInterestTypeId,
          secondmentInterestType: e.secondmentInterestType,
          isChecked: false,
        }));

        setInterestType(formattedInterestTypes as SecondaryInterestType[]);
      },
      onError: (error) => {
        console.error("Error fetching interest types:", error);
      },
    },
  );

  const {mutate: getComMainServices} = useMutation(
    () =>
      httpGET({
        url: "/ComMainService",
        params: {type: "SECONDMENT"},
      }),
    {
      onSuccess: (rs) => {
        setComMainService(rs as ComMainService[]);
      },
    },
  );

  const {mutate: getFirmAddresses} = useMutation(
    (id: any) =>
      httpGET({
        url: "/firm/firm-addresses",
        params: {id, type: "SECONDMENT"},
      }),
    {
      onSuccess: (rs) => {
        setFirmAddresses(rs as FirmAddress[]);
      },
    },
  );
  const {mutate: submitForm} = useMutation(
    (data: FormData) =>
      httpPUT({
        url: "/CommerceFirmData/secondment",
        data: data,
      }),
    {
      onSuccess: (rs) => {
        formRef.current?.resetForm();
        if (onEditSuccess){
          onEditSuccess(rs);
        }
        setSubmitCount(0);
        if (firmData?.commerceFirmData?.isDraff) {
          publicComplete();
        } else {
          handleClose();
        }
      },
      onError: (rs: any) => {
        showNotification(rs.message, "Error");
        if (rs.message.includes("delete")) {
          setSearchParams({...searchParams, tab: "secondment", serviceId: ""});
          handleErrorClose();
        } else {
          handleClose();
        }
      },
    },
  );

  useEffect(() => {
    if (visible) {
      initData(offeringId);
      setSearchParams(initSearchParams);
    } else {
      setFirmData(undefined);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, visible, organizationId]);

  useEffect(() => {
    if (organizationId && !firmData) {
      // this statment is for admin site
      getAgnetRegion(organizationId);
      getAddEditAgnetRegion(organizationId);
      getComMainServices();
      getCompracticeLevel();
      getInterestTypes();
    } else {
      // this statment is for firm site
      if (id && !firmData) {
        getAgnetRegion(
          user!.individual!.fkOrgId !== Number(id) ? Number(id) : user?.individual?.fkOrgId,
        );
        getAddEditAgnetRegion(user?.individual.fkOrgId);
        getComMainServices();
        getCompracticeLevel();
        getInterestTypes();
      }
      if (firmData?.commerceFirmData) {
        getFirmAddresses(firmData?.commerceFirmData.region);
        getIndividuals(firmData?.firmName?.orgId);
      }
    }

    /**
     * Will remove after checking on Monday
     * - Re-render Component continuously
     */
    // if (!visible && firmData) {
    //     setFirmData(undefined);
    // }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    getAgnetRegion,
    getAgnetRegion,
    getComMainServices,
    getCompracticeLevel,
    getFirmAddresses,
    getIndividuals,
    visible,
    firmData,
  ]);

  useEffect(() => {
    if (submitType !== undefined) {
      formRef.current?.submitForm();
      setSubmitCount(submitCount + 1);
      setSubmitType(undefined);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [submitType]);

  if (!agnetRegion) {
    return null;
  }

  if (!firmData || !agnetRegion || !comMainService || !firmAddresses || !compracticeLevel) {
    return null;
  }
  const initialValues = {
    mainServiceId: {
      label: firmData.tblComMainService?.mainServiceName,
      value: firmData.tblComMainService?.mainServiceId,
    },
    firmId: firmData?.firmName?.orgId,
    country: {
      value: firmAddresses?.findIndex((e) => e.fkOrgId === firmData?.firmName?.orgId),
      label: firmAddresses?.find((e) => e.fkOrgId === firmData?.firmName?.orgId)?.firmName1,
      firmId: firmData?.firmName?.orgId,
    },
    keyContact: firmData?.individual?.map((e: any) => {
      return {
        value: e.individualId,
        label: e.firstName + " " + e.lastName,
      };
    }),
    interestType: interestType?.map((e: any) => {
      return {
        value: e.secondmentInterestTypeId,
        label: e.secondmentInterestType,
        isChecked: firmData?.commerceFirmData?.comOfferingSecondmentInterestTypes?.find(
          (y) => y.fksecondmentInterestTypeId === e.secondmentInterestTypeId,
        )
          ? true
          : false,
      };
    }),
    detailedDescription: firmData?.commerceFirmData?.detailedDescription,
    region: {
      value: agnetRegion?.find((e) => e.netRegionId === firmData?.commerceFirmData?.region)
        ?.netRegionId,
      label: agnetRegion?.find((e) => e.netRegionId === firmData?.commerceFirmData?.region)
        ?.netRegionName,
    },
    title: firmData?.commerceFirmData?.title,
  };

  if (!visible || !firmData || !individual) {
    return null;
  }

  return (
    <AGModal
      toggleModal={() => {
        toggleModal();
        formRef.current?.resetForm();
        setSubmitCount(0);
        setIsDataChanged(!isDataChanged);
      }}
      title="Edit Secondment"
      footer={
        <div className="flex justify-between w-full">
          <AGButton
            onClick={() => {
              onDeleteService && onDeleteService(true);
            }}
            style={{minWidth: "128px"}}
            type="Danger"
          >
            Delete Secondment
          </AGButton>

          <AGButton
            type="Success"
            onClick={() => {
              setSubmitType("Publish");
            }}
            disabled={!isDataChanged}
          >
            Publish
          </AGButton>
        </div>
      }
      visible={visible}
      toolstip={true}
      titleTooltip={MODAL_CONSTANT.ADD_SECONDMENT}
    >
      <CustomBackground ref={componentRef}>
        <CommerceCompassStyled>
          <div className="print">
            <div>
              <Formik
                innerRef={formRef}
                validationSchema={UpdateCommerceSecondmentSchema}
                initialValues={initialValues}
                validateOnChange={submitCount >= 1}
                onSubmit={(values) => {
                  if (submitType !== undefined) {
                    const data = {
                      comFirmDataId: offeringId,
                      fkFirmId: values.firmId,
                      dateEntered: moment(values.today).toISOString(),
                      detailedDescription: values.detailedDescription.trim(),
                      region: values.region.value,
                      comContactIds: values.keyContact.map((e: any) => e.value),
                      interestingType: values.interestType
                        .filter((e: any) => e.isChecked)
                        .map((e: any) => e.value),
                      title: values.title.trim(),
                    } as any;
                    const formData = new FormData();

                    for (const key in data) {
                      const value = data[key];

                      if (Array.isArray(value)) {
                        value.forEach((item: any) => {
                          formData.append(`${key}`, JSON.stringify(item));
                        });
                      } else {
                        formData.append(key, value);
                      }
                    }
                    if (submitType === "Draff") {
                      formData.append("isDraff", JSON.stringify(true));
                      submitForm(formData);
                    }
                    if (submitType === "Publish") {
                      formData.append("isDraff", JSON.stringify(false));
                      submitForm(formData);
                    }
                  }
                }}
              >
                {({values, errors, setFieldValue}) => {
                  const isDirty = !isEqual(
                    {
                      ...values,
                    },
                    initialValues,
                  );

                  setIsDataChanged(isDirty);
                  
                  if (firmData.commerceFirmData?.isDraff) {
                    setIsDataChanged(true);
                  }

                  let messengeError = "";
                  Object.keys(errors).forEach(function (key, index) {
                    if (key === "compracticeLevelsCustom") {
                      const compracticeLevelsCustom: any = errors[key];

                      return (messengeError += compracticeLevelsCustom.find((f: any) => f?.isValid)
                        ? "Question 7" + (index === Object.keys(errors).length - 1 ? "." : ", ")
                        : "");
                    }

                    return (messengeError +=
                      errors[key]?.toString().replace("_", "").replace("+", "") +
                      (index === Object.keys(errors).length - 1 ? "." : ", "));
                  });

                  return (
                    <form>
                      <div>
                        <label
                          className="label-title"
                          htmlFor=""
                        >
                          Organization Region: <span className="required">*</span>
                        </label>
                        <div className="subtitle">
                          <span>Enter/ Select your answer</span>
                        </div>
                        <div className="custom-select">
                          <AGSelect
                            placeholder="Enter/ Select organization region"
                            onChange={(e: any) => {
                              getFirmAddresses({id: e?.value as any});
                              setFieldValue("region", e);
                              // if (e) {
                              //   setFieldValue("country", "");
                              // }
                            }}
                            value={values.region}
                            options={agnetRegion?.map((e) => {
                              return {
                                value: e.netRegionId,
                                label: e.netRegionName,
                              };
                            })}
                            isDisabled={true}
                          />
                          {errors.region && (
                            <div className="error">This question is required. </div>
                          )}
                        </div>
                      </div>
                      <RolesHandle
                        firmId={ADMIN_ORGANIZATION.ID}
                        fkOrgId={ADMIN_ORGANIZATION.ID}
                        roles={["Admin"]}
                      >
                        <div>
                          <label
                            className="label-title"
                            htmlFor=""
                          >
                            Organization Name: <span className="required">*</span>
                          </label>
                          <div className="subtitle">
                            <span>Please Select Organization.</span>
                          </div>
                          <AGSelect
                            placeholder="Enter/ Select organization name"
                            value={values.country}
                            onChange={(e: any) => {
                              getIndividuals(e?.fkOrgId as any);
                              setFieldValue("firmId", e?.fkOrgId);
                              setFieldValue("country", e);
                              //   if (e) {
                              //     getServices(e.fkOrgId);
                              //   }
                            }}
                            options={firmAddresses?.map((e, index) => {
                              return {
                                value: index,
                                label: e.firmName1 + " - " + e.country,
                                fkOrgId: e.fkOrgId,
                                disabled:
                                  e.createdProducts &&
                                  e.createdProducts >= user?.individual.productMaximumQuantity!
                                    ? true
                                    : false,
                              };
                            })}
                            isOptionDisabled={(option: any) => option.disabled}
                            isDisabled={true}
                          />
                          {errors.country && (
                            <div className="error">This question is required. </div>
                          )}
                        </div>
                      </RolesHandle>

                      <div>
                        <label className="label-title">
                          Title: <span className="required">{" "}*
                          {/* <Tooltip
                              text={
                                <div className="tool-tip">
                                  Provide a short description of the secondment, including the expected start date and how long the assignment will last. This helps align expectations and identify the right match.
                                </div>
                              }
                            /> */}
                          </span>
                        </label>
                        <div
                          data-tip="Tooltip content"
                          className="subtitle"
                        >
                          Please enter the secondment title.
                        </div>
                        <AGInput
                          maxLength={150}
                          placeholder="Enter your answer"
                          // className="text-area"
                          value={values.title}
                          onChange={(e) => {
                            setFieldValue("title", e.target.value);
                          }}
                        />
                        {errors.title && (
                          <div className="error">This question is required.</div>
                        )}
                      </div>

                      <div>
                        <label
                          className="label-title"
                          htmlFor=""
                        >
                          Key Contact(s): <span className="required">*</span>
                        </label>
                        <div
                          data-tip="Tooltip content"
                          className="subtitle"
                        >
                          Select a maximum of 3 key contacts. If a key contact for your organization
                          isn’t listed, ask your organization’s AG Champion to get them added to our
                          database.
                        </div>
                        <AGSelect
                          placeholder="Enter/ Select your answer"
                          value={values.keyContact}
                          onChange={(e: any) => {
                            if (e.length > 3) {
                              setFieldValue("keyContact", e.slice(1, 4));
                            } else {
                              setFieldValue("keyContact", e);
                            }
                          }}
                          options={individual
                            ?.sort((a, b) =>
                              a.firstName + " " + a.lastName > b.firstName + " " + b.lastName
                                ? 1
                                : b.firstName + " " + b.lastName > a.firstName + " " + a.lastName
                                ? -1
                                : 0,
                            )
                            .map((e) => {
                              return {
                                value: e.individualId,
                                label: e.firstName + " " + e.lastName,
                              };
                            })}
                          isMulti
                        />
                        {errors.keyContact && (
                          <div className="error">This question is required.</div>
                        )}
                      </div>

                      <label className="label-title">
                        Interest Type:{" "}
                        <span className="required">
                          *
                          <Tooltip
                            text={
                              <div className="tool-tip">
                                Let us know if your firm is offering or seeking a secondee and the
                                area of specialization.
                              </div>
                            }
                          />
                        </span>
                      </label>
                      <div
                        style={{
                          borderRadius: "7px",
                          padding: "0px 10px",
                          border: "1px solid rgb(223, 228, 234)",
                        }}
                      >
                        {interestType?.map((e: any, index: number) => (
                          <label
                            key={index}
                            style={{
                              marginTop: 10,
                              marginBottom: 20,
                              display: "flex",
                              gap: 10,
                              alignItems: "start",
                            }}
                            className="flex items-center"
                          >
                            <AGCheckbox
                              defaultChecked={true}
                              value={values.interestType[index]?.isChecked ? "true" : "false"}
                              disabled={true}
                              onChange={() => {
                                setFieldValue(
                                  `interestType.${index}.isChecked`,
                                  !values.interestType[index]?.isChecked,
                                );
                              }}
                            />
                            <div>
                              <span className="service-available-options">
                                {e.secondmentInterestType}
                              </span>
                            </div>
                          </label>
                        ))}
                      </div>
                      {errors.interestType && (
                        <div className="error">This question is required.</div>
                      )}

                      <div>
                        <label
                          className="label-title"
                          htmlFor=""
                        >
                          Specialized Service:{" "}
                          <span className="required">
                            {" "}
                            *
                            <Tooltip
                              text={
                                <div className="tool-tip">
                                  Select a specialized service area to feature.
                                  Complete and submit another Commerce Service Profile for any additional specialized services you wish to feature.
                                  If you would like to feature a specialized service area that is not listed,
                                  please email{" "}
                                  <a
                                    href={`mailto:${
                                      process.env.REACT_APP_CONTACT_SUPPORT_MAIL ||
                                      "techsupport@allinialglobal.com"
                                    }`}
                                    className="linkified"
                                  >
                                    {process.env.REACT_APP_CONTACT_SUPPORT_MAIL ||
                                      "techsupport@allinialglobal.com"}
                                  </a>{" "}
                                  to request it to be added.
                                </div>
                              }
                            />
                          </span>
                        </label>
                        <div>
                          <AGSelect
                            isDisabled
                            placeholder="Enter/ Select Specialized Service"
                            value={values.mainServiceId}
                            onChange={(e: any) => {
                              setFieldValue("mainServiceId", e);
                            }}
                            options={comMainService
                              ?.sort((a, b) => a.mainServiceName!.localeCompare(b.mainServiceName!))
                              .map((e) => {
                                return {
                                  value: e.mainServiceId,
                                  label: e.mainServiceName,
                                };
                              })}
                            isOptionDisabled={(option: any) => option.disabled}
                          />
                        </div>
                        {errors.mainServiceId && (
                          <div className="error">This question is required.</div>
                        )}
                      </div>
                      <div>
                        <label className="label-title">
                          Duration & Description:{" "}
                          <span className="required">
                            *
                            <Tooltip
                              text={
                                <div className="tool-tip">
                                  Provide a short description of the secondment, including the
                                  expected start date and how long the assignment will last. This
                                  helps align expectations and identify the right match.
                                </div>
                              }
                            />
                          </span>
                        </label>
                        <div
                          data-tip="Tooltip content"
                          className="subtitle"
                        >
                          Please enter the duration & description of secondment.
                        </div>
                        <AGtextarea
                          maxLength={300}
                          placeholder="Enter your answer"
                          className="text-area"
                          value={values.detailedDescription}
                          onChange={(e) => {
                            setFieldValue("detailedDescription", e.target.value);
                          }}
                        />
                        {errors.detailedDescription && (
                          <div className="error">This question is required.</div>
                        )}
                      </div>
                    </form>
                  );
                }}
              </Formik>
            </div>
          </div>
        </CommerceCompassStyled>
      </CustomBackground>
    </AGModal>
  );
};
export default UpdateSecondmentModal;
